'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "href", "disabled", "active", "isHover", "isFocus", "component", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Link } from "./Link.mjs";
import { ListItem } from "./ListItem.mjs";
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { textClass } from "../../styles/layout-theme.mjs";
/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsItem component with instead.
 */
export var NavPillListItem = /*#__PURE__*/React.forwardRef(function NavPillListItem(_ref, ref) {
  var label = _ref.label,
    href = _ref.href,
    disabled = _ref.disabled,
    active = _ref.active,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var tabIndexAttribute = active ? null : {
    tabIndex: '-1'
  };
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(ListItem, {
    role: "presentation",
    "data-encore-id": ENCORE_DATA_IDS.NavPillListItem
  }, /*#__PURE__*/React.createElement(Link, Object.assign({
    ref: ref,
    className: cx(textClass('bodySmallBold'), className),
    role: "tab"
  }, tabIndexAttribute, {
    isActive: active,
    isHover: isHover,
    isFocus: isFocus,
    component: component,
    href: !disabled ? href : undefined,
    disabled: disabled,
    "aria-disabled": disabled,
    "aria-selected": active,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
  }, props), label));
});